// Clarity Images
import FL from "Assets/Image/Grading/Clarity/FL.png";
import I from "Assets/Image/Grading/Clarity/I.png";
import SI from "Assets/Image/Grading/Clarity/SI.png";
import VS from "Assets/Image/Grading/Clarity/VS.png";
import VVS from "Assets/Image/Grading/Clarity/VVS.png";

// Color Images
import D2F from "Assets/Image/Grading/Color/D-F.png";
import G2H from "Assets/Image/Grading/Color/G-H.png";
import I2J from "Assets/Image/Grading/Color/I-J.png";
import K2M from "Assets/Image/Grading/Color/K-M.png";
import N2R from "Assets/Image/Grading/Color/N-R.png";
import S2Z from "Assets/Image/Grading/Color/S-Z.png";
import FANCY from "Assets/Image/Grading/Color/Fancy.png";

// Floro Images
import FAINT from "Assets/Image/Grading/Floro/faint.png";
import MEDIUM from "Assets/Image/Grading/Floro/medium.png";
import NONE from "Assets/Image/Grading/Floro/none.png";
import STRONG from "Assets/Image/Grading/Floro/strong.png";
import VERY_STRONG from "Assets/Image/Grading/Floro/very-strong.png";

// Inclusion Images
import Bearding from "Assets/Image/Grading/Inclusion/Bearding.png";
import Cavity from "Assets/Image/Grading/Inclusion/Cavity.png";
import Bruise from "Assets/Image/Grading/Inclusion/Bruise.png";
import Cloude from "Assets/Image/Grading/Inclusion/Cloude.png";
import Crystal from "Assets/Image/Grading/Inclusion/Crystal.png";
import Feather from "Assets/Image/Grading/Inclusion/Feather.png";
import InternalGraining from "Assets/Image/Grading/Inclusion/InternalGraining.png";
import Knots from "Assets/Image/Grading/Inclusion/Knots.png";
import LaserDrillHole from "Assets/Image/Grading/Inclusion/LaserDrillHole.png";
import Needle from "Assets/Image/Grading/Inclusion/Needle.png";
import Pinpoint from "Assets/Image/Grading/Inclusion/Pinpoint.png";
import TwinningWisp from "Assets/Image/Grading/Inclusion/TwinningWisp.png";

// Inclusion ORG Images
import Bearding_Org from "Assets/Image/Grading/Inclusion/Org/bearded.png";
import Cavity_Feather_Org from "Assets/Image/Grading/Inclusion/Org/cavity.png";
import Bruise_Org from "Assets/Image/Grading/Inclusion/Org/bruises.png";
import Cloud_Org from "Assets/Image/Grading/Inclusion/Org/clouds.png";
import Crystal_Org from "Assets/Image/Grading/Inclusion/Org/crystals.png";
import Feather_Org from "Assets/Image/Grading/Inclusion/Org/feathers.png";
import Internal_Graining_Org from "Assets/Image/Grading/Inclusion/Org/grainingInternal.png";
import Knot_Org from "Assets/Image/Grading/Inclusion/Org/knots.png";
import Laser_Drill_Hole_Org from "Assets/Image/Grading/Inclusion/Org/InternalLaserDrilling.png";
import Needle_Org from "Assets/Image/Grading/Inclusion/Org/needles.png";
import Pinpoint_Org from "Assets/Image/Grading/Inclusion/Org/pinpoints.png";
import Twinning_Wisp_Org from "Assets/Image/Grading/Inclusion/Org/twinningWisps.png";

export const CARAT_RANGES = [
  [
    "0.001 - 0.079",
    "0.080 - 0.139",
    "0.140 - 0.179",
    "0.180 - 0.229",
    "0.230 - 0.299",
    "0.30 - 0.39",
    "0.40 - 0.49",
    "0.50 - 0.69",
    "0.70 - 0.89",
    
  ],
  [
    "0.90 - 0.99",
    "1.00 - 1.49",
    "1.50 - 1.99",
    "2.00 - 2.99",
    "3.00 - 3.99",
    "4.00 - 4.99",
    "5.00 - 5.99",
    "6.00 - 9.99",
    "10.00 +",
  ],
];

export const CLARITY = [
  {
    img: FL,
    title: "FL - Flaw Less",
    subtitle: "IF - Internally Flaw Less",
  },
  {
    img: VVS,
    title: "VVS1 / VVS2",
    subtitle: "Very Very Slightly Included",
  },
  {
    img: VS,
    title: "VS1 / VS2",
    subtitle: "Very Slightly Included",
  },
  {
    img: SI,
    title: "SI1 / SI2 / SI3",
    subtitle: "Slightly Included",
  },
  {
    img: I,
    title: "I1 / I2 / I3",
    subtitle: "Included",
  },
];

export const COLOR = [
  { img: D2F, title: "D | E | F", subtitle: "Colorless" },
  { img: G2H, title: "G | H", subtitle: "Near Colorless" },
  { img: I2J, title: "I | J", subtitle: "Slightly Tinted" },
  { img: K2M, title: "K | L | M", subtitle: "Faint" },
  { img: N2R, title: "N | O-P | Q-R", subtitle: "Very Light" },
  { img: S2Z, title: "S-T | U-V | W-X | Y-Z", subtitle: "Light" },
  { img: FANCY, title: "FANCY", subtitle: "Yellow" },
];

export const CUT_DATA = [
  { code: "EX", label: "Excellent Cut" },
  { code: "VG", label: "Very Good Cut" },
  { code: "GD", label: "Good Cut" },
  { code: "F", label: "Fair Cut" },
];

export const POLISH_DATA = [
  { code: "EX", label: "Excellent Polish" },
  { code: "VG", label: "Very Good Polish" },
  { code: "GD", label: "Good Polish" },
  { code: "F", label: "Fair Polish" },
];

export const SYMMETRY_DATA = [
  { code: "EX", label: "Excellent Symmetry" },
  { code: "VG", label: "Very Good Symmetry" },
  { code: "GD", label: "Good Symmetry" },
  { code: "F", label: "Fair Symmetry" },
];

export const FLUORESCENCE_DATA = [
  { code: "NON", label: "None", img: NONE },
  { code: "FNT", label: "Faint", img: FAINT },
  { code: "MED", label: "Medium", img: MEDIUM },
  { code: "STG", label: "Strong", img: STRONG },
  { code: "VST", label: "Very Strong", img: VERY_STRONG },
];

export const HEART_ARROW_DATA = ["Excellent", "Very Good", "Good", "None"];

export const LUSTER_DATA = ["EX", "VG", "GD"];
export const LUSTER_LABELS = ["Excellent", "Very Good", "Good"];

export const SHADE_DATA = [
  ["NON", "GREEN", "YELLOW", "PINK", "BLUE"],
  ["BROWN", "GREY", "YELLOW - BROWN", "YELLOW - GREEN", "MIXED"],
];

export const EXTRA_FACET_DATA = ["SM", "MD", "HV", "NONE"];
export const EXTRA_FACET_LABELS = ["Small", "Medium", "Heavy", "None"];

export const WHITE_INCLUSION = [
  {
    type: "Clouds",
    detail:
      "– A cluster of tiny white pinpoint inclusions that create a hazy effect.",
  },
  {
    type: "Feathers",
    detail: "– Internal fractures that appear as white or translucent lines.",
  },
  {
    type: "Needles",
    detail: "– Long, thin white inclusions that resemble tiny rods.",
  },
  {
    type: "Crystals",
    detail: "– White mineral deposits inside the diamond.",
  },
  {
    type: "Graining",
    detail: "– Internal growth patterns that can create a milky appearance.",
  },
];

export const BLACK_INCLUSION = [
  {
    type: "Black Crystals",
    detail:
      "– Dark mineral deposits, often of minerals like pyrite or graphite, that can be embedded within the diamond.",
  },
  {
    type: "Pinpoints",
    detail:
      "– Very small black inclusions that may appear as tiny dots scattered within the diamond.",
  },
  {
    type: "Black Twinning Wisps",
    detail:
      "– Dark thread-like inclusions formed by the intergrowth of crystal structures in a diamond.",
  },
  {
    type: "Dark Clouds",
    detail:
      "– Clusters of dark inclusions that can create a shadowy or smoky effect within the diamond.",
  },
  {
    type: "Needles",
    detail:
      "– Thin, black, hair-like inclusions that can look similar to black threads.",
  },
  {
    type: "Black Feathers",
    detail:
      "– Fractures or cleavages that appear as dark lines within the stone, often indicating internal stress.",
  },
];

export const INCLUSION_TABLE = [
  ["Table White Inclusion", "Side White Inclusion"],
  ["Table Black Inclusion", "Side Black Inclusion"],
];

export const INCLUSION_CRITERIA = [
  ["None", "ML", "SM", "MD", "LRG"],
  ["None", "Meaningless", "Small", "Medium", "Large"],
];

export const OPEN_INCLUSION = [
  [
    "None",
    "Hair line Open inclusion",
    "Small Open inclusion",
    "Medium Open inclusion",
    "Large Open inclusion",
  ],
];

export const OPEN_INCLUSION_SEPARATION = [
  ["Open on Table", "Open on Crown", "Open on Pavilion", "Open on Girdle"],
];

export const INCLUSIONS = [
  {
    mainImg: Bearding,
    OrgImg: Bearding_Org,
    name: "Bearding",
  },
  {
    mainImg: Cavity,
    OrgImg: Cavity_Feather_Org,
    name: "Cavity",
  },
  {
    mainImg: Bruise,
    OrgImg: Bruise_Org,
    name: "Bruise",
  },
  {
    mainImg: Cloude,
    OrgImg: Cloud_Org,
    name: "Cloude",
  },
  {
    mainImg: Crystal,
    OrgImg: Crystal_Org,
    name: "Crystal",
  },
  {
    mainImg: Feather,
    OrgImg: Feather_Org,
    name: "Feather",
  },
  {
    mainImg: InternalGraining,
    OrgImg: Internal_Graining_Org,
    name: "Internal Graining",
  },
  {
    mainImg: Knots,
    OrgImg: Knot_Org,
    name: "Knots",
  },
  {
    mainImg: LaserDrillHole,
    OrgImg: Laser_Drill_Hole_Org,
    name: "Laser Drill Hole",
  },
  {
    mainImg: Needle,
    OrgImg: Needle_Org,
    name: "Needle",
  },
  {
    mainImg: Pinpoint,
    OrgImg: Pinpoint_Org,
    name: "Pinpoint",
  },
  {
    mainImg: TwinningWisp,
    OrgImg: Twinning_Wisp_Org,
    name: "Twinning Wisps",
  },
];